<template>
    <div  id="app">
    <router-view/>
    </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
    }
  },
  created () {
  }
}
</script>
<style scoped>

.content {
    flex: auto;
}
</style>
<style>
    @import "assets/css/bootstrap.css";
    @import "assets/css/bootstrap-vue.css";
    @import "assets/css/style.css";
    @import "assets/fontawesome/all.css";
</style>
